const ImportIcon = () => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.7605 22.2503H9.24047C4.33047 22.2503 2.23047 20.1503 2.23047 15.2403V15.1103C2.23047 10.6703 3.98047 8.53027 7.90047 8.16027C8.30047 8.13027 8.68047 8.43027 8.72047 8.84027C8.76047 9.25027 8.46047 9.62027 8.04047 9.66027C4.90047 9.95027 3.73047 11.4303 3.73047 15.1203V15.2503C3.73047 19.3203 5.17047 20.7603 9.24047 20.7603H15.7605C19.8305 20.7603 21.2705 19.3203 21.2705 15.2503V15.1203C21.2705 11.4103 20.0805 9.93027 16.8805 9.66027C16.4705 9.62027 16.1605 9.26027 16.2005 8.85027C16.2405 8.44027 16.5905 8.13027 17.0105 8.17027C20.9905 8.51027 22.7705 10.6603 22.7705 15.1303V15.2603C22.7705 20.1503 20.6705 22.2503 15.7605 22.2503Z"
            />
            <path
                d="M12.5 15.63C12.09 15.63 11.75 15.29 11.75 14.88V2C11.75 1.59 12.09 1.25 12.5 1.25C12.91 1.25 13.25 1.59 13.25 2V14.88C13.25 15.3 12.91 15.63 12.5 15.63Z"
            />
            <path
                d="M12.4998 16.7498C12.3098 16.7498 12.1198 16.6798 11.9698 16.5298L8.61984 13.1798C8.32984 12.8898 8.32984 12.4098 8.61984 12.1198C8.90984 11.8298 9.38984 11.8298 9.67984 12.1198L12.4998 14.9398L15.3198 12.1198C15.6098 11.8298 16.0898 11.8298 16.3798 12.1198C16.6698 12.4098 16.6698 12.8898 16.3798 13.1798L13.0298 16.5298C12.8798 16.6798 12.6898 16.7498 12.4998 16.7498Z"
            />
        </svg>

    )
}

export default ImportIcon